import { render } from "./coupon-api.vue?vue&type=template&id=7454fe9a&scoped=true"
import script from "./coupon-api.vue?vue&type=script&lang=js"
export * from "./coupon-api.vue?vue&type=script&lang=js"

import "./coupon-api.vue?vue&type=style&index=0&id=7454fe9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7454fe9a"]])

export default __exports__